const pageName = {
  transactions: "Transactions",
  report: "Report",
  appManagement: "App Management",
  finance: "Finance",
  merchantKyc: "Merchant KYC",
  userManagement: "User Management",
  wayBill: "WayBill",
  recurring: "Recurring",
  virtualAccount: "VirtualAccount",
  download: "Download",
};

export default pageName;
